import { ComponentProps, ReactNode } from 'react';
import { Checkbox as AriaCheckbox } from 'react-aria-components';
import { Typography } from '../typography/typography';
import { Indicator } from './indicator';
import { CheckboxIndicatorVariants } from './variants';

type Props = {
  className?: string;
  children: ReactNode;
} & Omit<ComponentProps<typeof AriaCheckbox>, 'children' | 'className'> &
  CheckboxIndicatorVariants;

export function Checkbox(props: Props) {
  const { children, className, size, ...rest } = props;
  return (
    <AriaCheckbox
      className="flex items-center gap-x-12 text-grayscale500 cursor-pointer group"
      {...rest}
    >
      <Indicator size={size} />
      <Typography className="text-currentColor">{children}</Typography>
    </AriaCheckbox>
  );
}
